import { render, staticRenderFns } from "./wellcome.vue?vue&type=template&id=27365170&scoped=true"
import script from "./wellcome.vue?vue&type=script&lang=js"
export * from "./wellcome.vue?vue&type=script&lang=js"
import style0 from "./wellcome.vue?vue&type=style&index=0&id=27365170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27365170",
  null
  
)

export default component.exports